module.exports = __webpack_public_path__ + "img/constructor.9296959d.svg";